import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function VaroToVaro({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M4 5.99999C4 4.15904 5.49238 2.66666 7.33333 2.66666C9.17428 2.66666 10.6667 4.15904 10.6667 5.99999V7.33332C10.6667 9.17427 9.17428 10.6667 7.33333 10.6667C5.49238 10.6667 4 9.17427 4 7.33332V5.99999ZM7.33333 3.99999C6.22876 3.99999 5.33333 4.89542 5.33333 5.99999V7.33332C5.33333 8.43789 6.22876 9.33332 7.33333 9.33332C8.4379 9.33332 9.33333 8.43789 9.33333 7.33332V5.99999C9.33333 4.89542 8.4379 3.99999 7.33333 3.99999Z"
        fill={iconColor}
      />
      <Path
        d="M11.3333 16.6667C11.3333 15.6058 10.9119 14.5884 10.1618 13.8382C9.68215 13.3585 9.0932 13.0133 8.45349 12.8266C8.09282 12.7214 7.71601 12.6667 7.33356 12.6667C6.80827 12.6666 6.28806 12.77 5.80274 12.971C5.31742 13.172 4.87644 13.4666 4.50499 13.8381C4.13353 14.2095 3.83887 14.6505 3.63784 15.1358C3.4368 15.6212 3.33333 16.1413 3.33333 16.6667H2C2 15.9662 2.13796 15.2727 2.406 14.6256C2.67405 13.9785 3.06692 13.3905 3.5622 12.8952C4.05748 12.4 4.64546 12.0072 5.29256 11.7392C5.93965 11.4712 6.63318 11.3333 7.33356 11.3333C8.74797 11.3333 10.1045 11.8952 11.1046 12.8954C11.4604 13.2512 11.7607 13.6521 12 14.0846C12.241 13.6491 12.5422 13.2486 12.8955 12.8952C13.3908 12.4 13.9788 12.0072 14.6259 11.7392C15.273 11.4712 15.9665 11.3333 16.6669 11.3333C18.0813 11.3333 19.4378 11.8952 20.438 12.8954C21.4381 13.8956 22 15.2522 22 16.6667H20.6667C20.6667 15.6058 20.2453 14.5884 19.4951 13.8382C19.0155 13.3585 18.4265 13.0133 17.7868 12.8266C17.4262 12.7214 17.0493 12.6667 16.6669 12.6667C16.1416 12.6666 15.6214 12.77 15.1361 12.971C14.6508 13.172 14.2098 13.4666 13.8383 13.8381C13.4669 14.2095 13.1722 14.6505 12.9712 15.1358C12.7701 15.6212 12.6667 16.1413 12.6667 16.6667H11.3333Z"
        fill={iconColor}
      />
      <Path
        d="M13.3333 5.99999C13.3333 4.15904 14.8257 2.66666 16.6667 2.66666C18.5076 2.66666 20 4.15904 20 5.99999V7.33332C20 9.17427 18.5076 10.6667 16.6667 10.6667C14.8257 10.6667 13.3333 9.17427 13.3333 7.33332V5.99999ZM16.6667 3.99999C15.5621 3.99999 14.6667 4.89542 14.6667 5.99999V7.33332C14.6667 8.43789 15.5621 9.33332 16.6667 9.33332C17.7712 9.33332 18.6667 8.43789 18.6667 7.33332V5.99999C18.6667 4.89542 17.7712 3.99999 16.6667 3.99999Z"
        fill={iconColor}
      />
      <Path
        d="M19.4714 18.8619L15.8047 15.1953L14.8619 16.1381L17.3905 18.6667H2V20H17.3905L14.8619 22.5286L15.8047 23.4714L19.4714 19.8047C19.7318 19.5444 19.7318 19.1223 19.4714 18.8619Z"
        fill={iconColor}
      />
    </Svg>
  );
}
